import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import LinkComponent from './LinkComponent'

const SmallSwiperImage = ({ title, slug, imageSrc, route, bgColor = 'bg-maincolortrans' }) => {
    const imageLink = imageSrc || `/images/thonglor.png`

    return (
        <LinkComponent href={`/${route}/${slug}`} className='relative district-swiper-small-image w-[200px] h-[200px]' >
            <div className='w-[190px] h-[190px] relative overflow-hidden rounded-sm shadow-md'>
                <Image
                    src={imageLink}
                    fill='true'
                    className='object-cover'
                    alt={slug}
                />
                <div className='absolute bottom-0 left-0 right-0 rounded-b-sm flex justify-center h-[50px] items-start bg-maincolor/60 overflow-hidden' style={{ borderTop: `${bgColor} 1px solid` }}>
                    <h3 className={`text-light z-10 px-1 rounded-sm text-md text-center font-semibold`}>{title}</h3>
                </div>
            </div>
        </LinkComponent >
    )
}

export default SmallSwiperImage